var Handlebars = require('/app/node_modules/handlebars/runtime.js');
module.exports = (Handlebars['default'] || Handlebars).template({"1":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "    <cat-header id=\"header\"></cat-header>\n    <cat-content id=\"content\" class=\""
    + alias2(alias1(((stack1 = (depths[1] != null ? lookupProperty(depths[1],"css") : depths[1])) != null ? lookupProperty(stack1,"flex") : stack1), depth0))
    + "\"></cat-content>\n    <cat-footer id=\"footer\" class=\""
    + alias2(alias1(((stack1 = (depths[1] != null ? lookupProperty(depths[1],"css") : depths[1])) != null ? lookupProperty(stack1,"block") : stack1), depth0))
    + "\"></cat-footer>\n";
},"3":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "    <cat-header id=\"header\"></cat-header>\n    <cat-content id=\"content\" class=\""
    + container.escapeExpression(container.lambda(((stack1 = (depths[1] != null ? lookupProperty(depths[1],"css") : depths[1])) != null ? lookupProperty(stack1,"flex") : stack1), depth0))
    + "\"></cat-content>\n";
},"5":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "    <cat-header id=\"header\"></cat-header>\n    <cat-order-header id=\"order-header\"></cat-order-header>\n    <cat-content id=\"content\" class=\""
    + alias2(alias1(((stack1 = (depths[1] != null ? lookupProperty(depths[1],"css") : depths[1])) != null ? lookupProperty(stack1,"flex") : stack1), depth0))
    + " "
    + alias2(alias1(((stack1 = (depths[1] != null ? lookupProperty(depths[1],"css") : depths[1])) != null ? lookupProperty(stack1,"blue") : stack1), depth0))
    + "\"></cat-content>\n    <cat-footer id=\"footer\" class=\""
    + alias2(alias1(((stack1 = (depths[1] != null ? lookupProperty(depths[1],"css") : depths[1])) != null ? lookupProperty(stack1,"block") : stack1), depth0))
    + "\"></cat-footer>\n";
},"7":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "    <cat-error-page id=\"error-page\" class=\""
    + alias2(alias1(((stack1 = (depths[1] != null ? lookupProperty(depths[1],"css") : depths[1])) != null ? lookupProperty(stack1,"flex") : stack1), depth0))
    + " "
    + alias2(alias1(((stack1 = (depths[1] != null ? lookupProperty(depths[1],"css") : depths[1])) != null ? lookupProperty(stack1,"centred") : stack1), depth0))
    + " "
    + alias2(alias1(((stack1 = (depths[1] != null ? lookupProperty(depths[1],"css") : depths[1])) != null ? lookupProperty(stack1,"white") : stack1), depth0))
    + "\"></cat-error-page>\n";
},"9":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "    <cat-header id=\"header\"></cat-header>\n    <cat-auth id=\"auth\" class=\""
    + alias2(alias1(((stack1 = (depths[1] != null ? lookupProperty(depths[1],"css") : depths[1])) != null ? lookupProperty(stack1,"flex") : stack1), depth0))
    + " "
    + alias2(alias1(((stack1 = (depths[1] != null ? lookupProperty(depths[1],"css") : depths[1])) != null ? lookupProperty(stack1,"grey") : stack1), depth0))
    + " "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depths[1] != null ? lookupProperty(depths[1],"atCenter") : depths[1]),{"name":"if","hash":{},"fn":container.program(10, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":25,"column":63},"end":{"line":25,"column":107}}})) != null ? stack1 : "")
    + "\"></cat-auth>\n    <cat-footer id=\"footer\"></cat-footer>\n";
},"10":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return container.escapeExpression(container.lambda(((stack1 = (depths[1] != null ? lookupProperty(depths[1],"css") : depths[1])) != null ? lookupProperty(stack1,"centred") : stack1), depth0));
},"12":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, alias1=container.lambda, alias2=container.escapeExpression, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "    <cat-header id=\"header\"></cat-header>\n    <cat-payment id=\"payment\" class=\""
    + alias2(alias1(((stack1 = (depths[1] != null ? lookupProperty(depths[1],"css") : depths[1])) != null ? lookupProperty(stack1,"flex") : stack1), depth0))
    + " "
    + alias2(alias1(((stack1 = (depths[1] != null ? lookupProperty(depths[1],"css") : depths[1])) != null ? lookupProperty(stack1,"centred") : stack1), depth0))
    + " "
    + alias2(alias1(((stack1 = (depths[1] != null ? lookupProperty(depths[1],"css") : depths[1])) != null ? lookupProperty(stack1,"white") : stack1), depth0))
    + "\"></cat-payment>\n    <cat-footer id=\"footer\"></cat-footer>\n";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data,blockParams,depths) {
    var stack1, alias1=depth0 != null ? depth0 : (container.nullContext || {}), alias2=container.hooks.helperMissing, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||alias2).call(alias1,(depth0 != null ? lookupProperty(depth0,"layout") : depth0),"===","main",{"name":"compare","hash":{},"fn":container.program(1, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":0},"end":{"line":5,"column":12}}})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||alias2).call(alias1,(depth0 != null ? lookupProperty(depth0,"layout") : depth0),"===","footless",{"name":"compare","hash":{},"fn":container.program(3, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":7,"column":0},"end":{"line":10,"column":12}}})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||alias2).call(alias1,(depth0 != null ? lookupProperty(depth0,"layout") : depth0),"===","order",{"name":"compare","hash":{},"fn":container.program(5, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":12,"column":0},"end":{"line":17,"column":12}}})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||alias2).call(alias1,(depth0 != null ? lookupProperty(depth0,"layout") : depth0),"===","error",{"name":"compare","hash":{},"fn":container.program(7, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":19,"column":0},"end":{"line":21,"column":12}}})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||alias2).call(alias1,(depth0 != null ? lookupProperty(depth0,"layout") : depth0),"===","auth",{"name":"compare","hash":{},"fn":container.program(9, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":23,"column":0},"end":{"line":27,"column":12}}})) != null ? stack1 : "")
    + "\n"
    + ((stack1 = (lookupProperty(helpers,"compare")||(depth0 && lookupProperty(depth0,"compare"))||alias2).call(alias1,(depth0 != null ? lookupProperty(depth0,"layout") : depth0),"===","payment",{"name":"compare","hash":{},"fn":container.program(12, data, 0, blockParams, depths),"inverse":container.noop,"data":data,"loc":{"start":{"line":29,"column":0},"end":{"line":33,"column":12}}})) != null ? stack1 : "");
},"useData":true,"useDepths":true});


//////////////////
// WEBPACK FOOTER
// ./components/layout/layout/template.hbs
// module id = 985
// module chunks = 0